// extracted by mini-css-extract-plugin
export default {"wrapper":"styles_wrapper__Rv6Pr"};